<script>
let apiUrl = ''
let siteUrl = ''
let prefix = '/yinbaobiao'

switch (process.env.NODE_ENV) {
  case 'development':
    apiUrl = 'http://dev.api.yinbaobiao.com:8083' // api接口地址
    siteUrl = 'http://dev.yinbaobiao.com' // 本系统地址
    // apiUrl = 'https://sit-api.yinbaobiao.com' // api接口地址
    // siteUrl = 'https://sit.yinbaobiao.com' // 本系统地址
    break
  case 'sit':
    apiUrl = 'https://sit-api.yinbaobiao.com' // api接口地址
    siteUrl = 'https://sit.yinbaobiao.com' // 本系统地址
    break
  case 'production':
    apiUrl = 'https://api.yinbaobiao.com' // api接口地址
    siteUrl = 'https://www.yinbaobiao.com' // 本系统地址
    break
}
export default {
  apiUrl,
  siteUrl,
  prefix
}
</script>
